import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FuncaoService, Retencao } from 'eddydata-lib';
import { RetencaoService } from '../service/retencao.service';
import { success } from 'toastr';

@Component({
  selector: 'lib-retencao-reinf',
  templateUrl: './retencao-reinf.component.html'
})
export class RetencaoReinfComponent {
  @Input() retencao: Retencao;
  @Output() callback: EventEmitter<Retencao> = new EventEmitter();

  imaskConfig = {
    mask: Number,
    scale: 2,
    thousandsSeparator: '.',
    padFractionalZeros: true,
    normalizeZeros: true,
    radix: ','
  };

  paises: { codigo: number, nome: string }[] = [];

  constructor(private retencaoService: RetencaoService, private funcaoService: FuncaoService) { }

  salvar() {
    this.retencao.valor_aliquota = null;
    this.retencaoService.atualizar(this.retencao).subscribe((res) => {
      success('Informações adicionais para retenção salva com sucesso');
      this.retencao = res;
      this.callback.emit(this.retencao);
    }, (e) => { this.funcaoService.acaoErro(e) });
  }
}
